var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page-title',{attrs:{"titleText":_vm.pageTitle}}),_c('b-row',{staticClass:"no-gutters p-3"},[_c('b-button',{staticClass:"ml-auto",on:{"click":_vm.createUserAccount}},[_vm._v(" "+_vm._s(_vm.$t("button.addUser"))+" ")])],1),_c('b-col',{staticClass:"col-12 col-md-8 p-3 mx-auto"},[_c('user-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }